function getExtremumPeriod(event) {
  const extremum = [event?.readOnly?.jobfairBeginAt, event?.readOnly?.jobfairEndAt]
  return extremum;
}
export { getExtremumPeriod }
